var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmericanBall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "60px",
    height: "60px",
    viewBox: "0 0 36 36",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#662113",
    d: "M7.754 7.754C4.068 11.44 1.64 16.37.843 21.335l13.822 13.822c4.965-.797 9.895-3.225 13.581-6.911s6.114-8.616 6.911-13.581L21.335.843C16.37 1.64 11.44 4.068 7.754 7.754zm25.615-5.123C30.707 1.152 27.634.51 24.472.564l10.965 10.964c.053-3.162-.589-6.235-2.068-8.897zM2.631 33.369c2.662 1.479 5.736 2.121 8.898 2.067L.564 24.472c-.054 3.161.588 6.235 2.067 8.897z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E8ED",
    d: "M22.828 11.757l-2.414 2.414l-.707-.707a.999.999 0 1 0-1.414 1.414l.707.708L15.586 19l-.707-.707a.999.999 0 1 0-1.414 1.414l.707.707l-2.414 2.414l-.707-.707a.999.999 0 1 0-1.414 1.414l.707.707l-1 1a1 1 0 1 0 1.414 1.415l1-1l.707.707a.999.999 0 1 0 1.414-1.414l-.707-.707l2.414-2.414l.707.707a.999.999 0 1 0 1.414-1.414L17 20.414L20.414 17l.707.707a.999.999 0 1 0 1.414-1.414l-.707-.707l2.414-2.414l.707.707a1 1 0 1 0 1.414-1.414l-.707-.707l1-1a1 1 0 0 0-1.415-1.414l-1 1l-.707-.707a.999.999 0 1 0-1.414 1.414l.708.706zM.564 24.472l10.965 10.965a22.247 22.247 0 0 0 3.136-.279L.843 21.335a22.261 22.261 0 0 0-.279 3.137zM24.472.564c-1.04.018-2.088.111-3.136.279l13.822 13.822a22.26 22.26 0 0 0 .279-3.136L24.472.564z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanBall);
export default __webpack_public_path__ + "static/media/american_ball.381cca77a63926c016f287c7e7b8f9a9.svg";
export { ForwardRef as ReactComponent };